/* eslint-disable react/no-array-index-key */
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Slider from 'react-slick';
import { Grid } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import SliderButton from '../../../components/SliderButton/SliderButton';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{ paddingLeft: { xs: '16px', md: '32px', lg: '80px' } }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}

      >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function KeyBenefit({ keyBenefits }) {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [value, setValue] = useState(0);

  const play = () => {
    sliderRef.current.slickPlay();
  };
  const pause = () => {
    sliderRef.current.slickPause();
  };

  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: false,
    centerMode: false,
    swipeToSlide: true,
    focusOnSelect: false,
    rtl: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          slidesToShow: 2.9,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
          autoplay: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          infinite: true,
          slidesToShow: 2.2,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
          autoplay: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          swipeToSlide: true,
          autoplay: false,
        },
      },

    ],
  };

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const handleNavigation = (url) => {
    navigate(url);
  };

  return (
    <Grid
      className="key-section"
      sx={{
        justifyContent: 'center',
      }}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
        className="section-top">
        <Grid size={{ xs: 6, sm: 8 }}>
          <h2 className="box-title">{keyBenefits?.Title}</h2>
        </Grid>
        <Grid
          container
          size={{ xs: 6, sm: 4 }}
          sx={{
            justifyContent: 'flex-end',
          }}

          >
          <Button size="large" variant="contained" onClick={() => handleNavigation('/about')}>{keyBenefits?.buttonLabel?.slice(0, 30)}</Button>
        </Grid>
        <Grid size={{ sx: 12, sm: 8, md: 6 }}>  <div className="box-subtitle" dangerouslySetInnerHTML={{ __html: keyBenefits?.description }} /></Grid>
      </Grid>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: { xs: '0px 0px 0px 16px', md: '0px 0px 0px 32px', lg: '0px 28px 0px 80px' }, paddingRight: '0' }}>
          <Tabs value={value} onChange={handleChange} aria-label="fullWidth tabs" variant="fullWidth">
            {keyBenefits.tabs.map((item, idx) => <Tab
              key={item.id}
              label={item.label.slice(0, 25)}
              {...a11yProps(idx)}
              sx={{
                fontFamily: 'Playfair Display',
                textTransform: 'capitalize',
                fontSize: { xs: '14px', sm: '20px' },
                lineHeight: '30px',
                fontWeight: 500,
                color: '#666666',
                padding: { xs: '4px 3px', sm: '12px 16px' },
                minWidth: '100px',
                lineClamp: ' 1 !important',
                display: '-webkit-box !important',
                '-webkitLineClamp': ' 1 !important',
                '-webkitBoxOrient': 'vertical !important',
                overflow: ' hidden !important',
                height: { md: '50px' },
                '&.Mui-selected': {
                  color: '#01161E',
                  fontWeight: 700,
                },
              }}
            />)}

          </Tabs>
        </Box>
        <div>
          {keyBenefits.tabs.map((slides, idx) => (
            <CustomTabPanel
              key={idx}
              value={value}
              index={idx}
            >
              <div className="slider-container">
                <Slider ref={sliderRef} {...settings}>
                  {slides?.slides?.map((item, slideIdx) => (
                    <div className="slider-card" key={slideIdx} onMouseEnter={play} onMouseLeave={pause}>
                      <div className="slide-content">
                        <div className="image-container">
                          <img
                            src={`${item?.slideImage?.url}`}
                            className="image-slider"
                            alt=""
                          />
                        </div>
                        <div className="title">{item.title}</div>
                        <div className="description" dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </CustomTabPanel>
          ))}
        </div>
        <Grid sx={{ justifyContent: 'center', gap: '12px', marginBottom: '48px', display: { xs: 'none', md: 'flex' } }}>
          <SliderButton size="32px" onClick={() => sliderRef.current.slickPrev()} />
          <SliderButton isNext size="32px" onClick={() => sliderRef.current.slickNext()} />
        </Grid>
      </Box>
      <Grid />
    </Grid>

  );
}

export default KeyBenefit;
